import { Outlet, Link, useLocation, useNavigate } from 'react-router-dom';
import { usePwa } from '@/hooks/use-pwa';
import { useAuthStore } from '@/stores/auth-store';

const NAV_ITEMS = [
  { path: '/', label: 'Start', icon: '🏠' },
  { path: '/projects', label: 'Projekty', icon: '📁' },
] as const;

export function MainLayout() {
  const location = useLocation();
  const navigate = useNavigate();
  const { canInstall, isStandalone, isOfflineReady, install } = usePwa();
  const user = useAuthStore((s) => s.user);
  const logout = useAuthStore((s) => s.logout);

  return (
    <div className="flex min-h-dvh flex-col">
      {/* Install banner */}
      {canInstall && !isStandalone && (
        <div className="flex items-center justify-between bg-primary-600 px-4 py-2 text-white">
          <span className="text-xs">Zainstaluj Bransoletki Designer na swoim urządzeniu!</span>
          <button
            onClick={install}
            className="rounded-md bg-white px-3 py-1 text-xs font-semibold text-primary-700"
          >
            Zainstaluj
          </button>
        </div>
      )}

      {/* Top bar */}
      <header className="flex h-11 items-center justify-between border-b border-gray-200 bg-white px-4">
        <Link to="/" className="text-lg font-semibold text-primary-600">
          Bransoletki Designer
        </Link>
        <div className="flex items-center gap-2">
          {isOfflineReady && (
            <span className="rounded-full bg-green-100 px-2 py-0.5 text-[10px] text-green-700">
              Offline
            </span>
          )}
          {user && (
            <span className="hidden text-xs text-gray-500 sm:block">{user.email}</span>
          )}
          <button
            onClick={() => { logout(); navigate('/landing'); }}
            className="rounded-lg px-3 py-1.5 text-sm font-medium text-gray-600 hover:bg-gray-100"
          >
            Wyloguj
          </button>
        </div>
      </header>

      {/* Main content */}
      <main className="flex-1">
        <Outlet />
      </main>

      {/* Bottom navigation (mobile) */}
      <nav className="flex h-14 items-center justify-around border-t border-gray-200 bg-white pb-[var(--sab)] sm:hidden">
        {NAV_ITEMS.map((item) => {
          const isActive = location.pathname === item.path;
          return (
            <Link
              key={item.path}
              to={item.path}
              className={`flex flex-col items-center gap-0.5 text-xs ${
                isActive ? 'text-primary-600' : 'text-gray-500'
              }`}
            >
              <span className="text-lg">{item.icon}</span>
              <span>{item.label}</span>
            </Link>
          );
        })}
      </nav>
    </div>
  );
}
